module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-LightItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-LightItalic.woff
// module id = 51
// module chunks = 8